import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import type { RecruiterMetrics } from '@recruitai/shared';

interface RecruiterComparisonChartProps {
  data: RecruiterMetrics[];
}

export function RecruiterComparisonChart({ data }: RecruiterComparisonChartProps) {
  const chartData = data.map((r) => ({
    name: r.name.length > 15 ? r.name.slice(0, 15) + '…' : r.name,
    vagas: r.totalJobs,
    candidatos: r.totalCandidates,
    aprovacao: Math.round(r.approvalRate),
  }));

  return (
    <div className="bg-white rounded-lg border p-4">
      <h3 className="text-sm font-medium text-gray-700 mb-3">Comparativo de Recrutadores</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" tick={{ fontSize: 11 }} />
          <YAxis tick={{ fontSize: 11 }} />
          <Tooltip />
          <Legend />
          <Bar dataKey="vagas" name="Vagas" fill="#3b82f6" radius={[4, 4, 0, 0]} />
          <Bar dataKey="candidatos" name="Candidatos" fill="#34d399" radius={[4, 4, 0, 0]} />
          <Bar dataKey="aprovacao" name="Aprovação %" fill="#fbbf24" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
